import NextImage, { type ImageLoader, type ImageProps as NextImageProps } from 'next/image';
import { forwardRef } from 'react';

import { calmLoader } from '@/utils/imageLoader';

// Using forwardRef to avoid issues with styled-components v5
const Image = forwardRef<HTMLImageElement, NextImageProps>((props, _ref) => {
	if (process.env.IS_STORYBOOK) {
		return <NextImage {...props} unoptimized />;
	}

	// unset `loader` and set `unoptimized` for local images since they cannot be optimized
	let loader: ImageLoader | undefined;
	let unoptimized: boolean | undefined;
	if (typeof props.src === 'string') {
		if (props.src.startsWith('/_n/images/')) {
			loader = undefined;
			unoptimized = true;
		} else if (
			props.src.startsWith('https://assets.calm.com/') ||
			props.src.startsWith('https://assets-prod-usw.calm.com')
		) {
			loader = calmLoader;
			unoptimized = false;
		}
	} else if ('src' in props.src) {
		if (props.src.src.startsWith('/_next/static/media/')) {
			loader = undefined;
			unoptimized = true;
		}
	} else if ('default' in props.src) {
		if (props.src.default.src.startsWith('/_next/static/media/')) {
			loader = undefined;
			unoptimized = true;
		}
	}

	return <NextImage {...props} loader={loader} unoptimized={unoptimized} />;
});

Image.displayName = 'Image';

export default Image as typeof NextImage;
